import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import firebase from 'firebase'
import VueI18n from 'vue-i18n'

var firebaseConfig = {
    apiKey: "AIzaSyAjRUP9cJfmJZlqMW6xQD9AR3-XQ1ULmQo",
    authDomain: "letter-to-the-future.firebaseapp.com",
    databaseURL: "https://letter-to-the-future.firebaseio.com",
    projectId: "letter-to-the-future",
    storageBucket: "letter-to-the-future.appspot.com",
    messagingSenderId: "117017180158",
    appId: "1:117017180158:web:0732d093436a1eab6ab2af",
    measurementId: "G-FYEVDYTYNZ"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

Vue.config.productionTip = false
Vue.use(VueI18n)

const messages = {
  en: {
    app: {
      h1: 'Letter to the future',
      links: {
        inbox: 'Inbox',
        create: 'Write a Letter',
        auth: 'Sign In'
      }
    },
    inbox: {
      message: {
        noletters: 'I have not received the letter yet.'
      }
    },
    create: {
      th: {
        title: 'title',
        when: 'When will you receive it?'
      },
      button: {
        send: 'Send',
        ok: 'OK'
      },
      message: {
        complete: 'Sent！'
      }
    },
    auth: {
      button: {
        logout: 'LogOut',
        googleLogin: 'Login with Google',
        login: 'LogIn',
        signup: 'SignUp',
        signin: 'SignIn',
        turnMessage: '{en}'
      },
      message: {
        how: 'Sign up required to use.'
      },
      form: {
        email: 'email',
        password: 'password'
      }
    }
  },

  ja: {
    app: {
      h1: '未来への手紙',
      links: {
        inbox: '受信箱',
        create: '手紙を書く',
        auth: 'ログイン'
      }
    },
    inbox: {
      message: {
        noletters: 'まだ手紙を受け取っていません。'
      }
    },
    create: {
      th: {
        title: 'タイトル',
        when: 'いつ受け取りますか？'
      },
      button: {
        send: '送信',
        ok: 'OK'
      },
      message: {
        complete: '送信しました！'
      }
    },
    auth: {
      button: {
        logout: 'ログアウト',
        login: 'ログイン',
        googleLogin: 'Google認証',
        signup: '登録',
        signin: 'ログイン',
        turnMessage: '{ja}'
      },
      message: {
        how: 'ご利用いただくには登録が必要です。'
      },
      form: {
        email: 'メールアドレス',
        password: 'パスワード'
      }
    }
  }
}


const i18n = new VueI18n({
  locale: 'en',
  messages,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
